export default "__VITE_ASSET__gFP7sFOS__"